import React from "react";
import { FormLabel, InputAdornment } from "@material-ui/core";

import { DecimalNumberFieldControl } from "components/FormControl";

import {
  MACRONUTRIENTS_KEYS,
  MACRONUTRIENTS_REQUIRED_KEYS,
} from "../RecipeDetails";

import { getNutrientLabel, getUnits } from "utils/nutrients";

import {
  compose,
  decimalNumberDecimalPlacesLengthValidator,
  decimalNumberLengthValidator,
  numberFormatValidator,
} from "utils/validators";

import {
  Container,
  Column,
  NutrientContainer,
  TitleRow,
  NutrientsWrapper,
} from "./styles";

type Props = { name: string };

class MacroNutrientsControl extends React.Component<Props> {
  render() {
    const { name } = this.props;

    return (
      <Container>
        <TitleRow>
          <FormLabel>{"Nutrition Facts"}</FormLabel>
        </TitleRow>

        <NutrientsWrapper>
          {Object.values(MACRONUTRIENTS_KEYS).map(
            (value: string, index: number) => {
              const required = MACRONUTRIENTS_REQUIRED_KEYS.includes(value);
              return (
                <NutrientContainer key={`macronutrientKey:${index}`}>
                  <Column>
                    <FormLabel required={required}>
                      {getNutrientLabel(value)}
                    </FormLabel>
                  </Column>
                  <Column>
                    <DecimalNumberFieldControl
                      variant="outlined"
                      margin="none"
                      name={`${name}.${value}`}
                      required={required}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {getUnits(value)}
                          </InputAdornment>
                        ),
                      }}
                      validate={compose(
                        numberFormatValidator,
                        decimalNumberLengthValidator(12),
                        decimalNumberDecimalPlacesLengthValidator(2),
                      )}
                      onlyPositiveNumbers
                    />
                  </Column>
                </NutrientContainer>
              );
            },
          )}
        </NutrientsWrapper>
      </Container>
    );
  }
}

export default MacroNutrientsControl;
